var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconZeroStateLp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 20,
    y: 20,
    width: 30,
    height: 30,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.0%",
    y: "-3.3%",
    width: "113.3%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 30,
    y: 33,
    width: 10,
    height: 12,
    rx: 1.66666667
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50.0%",
    y: "-33.3%",
    width: "200.0%",
    height: "183.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-565.000000, -1350.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-zero-state-lp",
    transform: "translate(565.000000, 1350.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#9C89B8",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    rx: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "square",
    fill: "#B9E6FA",
    fillRule: "evenodd",
    x: 21,
    y: 21,
    width: 28,
    height: 28,
    rx: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26,20 L44,20 C47.3137085,20 50,22.6862915 50,26 L50,30 L20,30 L20,26 C20,22.6862915 22.6862915,20 26,20 Z",
    id: "Rectangle-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#1495CD",
    points: "22 30 48 30 48 37 22 40"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#5BC0EB",
    cx: 25.8333333,
    cy: 25.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#5BC0EB",
    cx: 30.8333333,
    cy: 25.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#5BC0EB",
    cx: 35.8333333,
    cy: 25.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZeroStateLp);
export default __webpack_public_path__ + "static/media/icon-zero-state-lp.448cd34c4e122f42b4aafbeabb7da3d3.svg";
export { ForwardRef as ReactComponent };